import { render } from "./DownloadsPDFComponent.vue?vue&type=template&id=5eacd054"
import script from "./DownloadsPDFComponent.vue?vue&type=script&lang=js"
export * from "./DownloadsPDFComponent.vue?vue&type=script&lang=js"

import "./DownloadsPDFComponent.vue?vue&type=style&index=0&id=5eacd054&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__